import { Badge } from 'src/design/atoms/Badge';
import React, { useMemo } from 'react';
import { OrganizationOfficeDto } from 'src/api/FiretrolApiClient';
import { IOrganizationOffice } from 'src/api/models/Organization';
import { BadgeShortList } from 'src/design/molecules/BadgeShortList';

export interface IOfficeListProps {
  offices: IOrganizationOffice[] | OrganizationOfficeDto[];
  maxItems?: number;
}

/** @registry Deduplicated, sorted list of office names as capped badges, via BadgeShortList. */
export const OfficeList = React.memo<IOfficeListProps>(
  ({ offices, maxItems = 1 }) => {
    const badges = useMemo(() => {
      const names = offices
        .map(
          (office: IOrganizationOffice | OrganizationOfficeDto) => office.name,
        )
        .reduce(
          (unique, name) =>
            unique.includes(name) ? unique : [...unique, name],
          [] as string[],
        )
        .sort();

      return names.map((name) => <Badge key={name}>{name}</Badge>);
    }, [offices]);

    return <BadgeShortList items={badges} maxItems={maxItems} />;
  },
);
